import React from 'react'
import './hobbies-style.css'

const Hobbies = ({ children }) => (<ul className='hobbies'>{children}</ul>)

export default Hobbies